import { Injectable } from '@angular/core';
import { AppService } from '../../app.service';
import * as _ from 'lodash-es';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { map, Subject, throwError } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GtwSnackbarService } from '../../shared/_services/gtw-snackbar.service';

@Injectable({
  providedIn: 'root',
})
export class GlobalService {
  filtersChanged$ = new Subject<void>();
  globalParamsChanged$ = new Subject<void>();

  private URLs = {
    getIssues: '/getIssues',
    getUserMenu: '/getUserNavigator',
    getUnreadMessageCount: '/getUnreadMesageCount',
    signout: '/logoutUser',
  };

  inputs!: {
    tax_year: {
      name: 'tax_year';
      label: 'Tax Year';
      selected: {
        scenario_type_code: string;
        value: string;
        scenario: string;
      };
      values: any[];
    };
  };

  global: any = {
    globalParams: {
      tax_year: '',
      screen_key: '',
      scenario: 1,
      scenario_v1: '',
      jcd_key: '',
      jcd_ta_key: '',
      activity_key: '',
      screen_type: '',
      is_locked: '',
      issue_id: '',
      issue_short_desc: '',
      issue_id_for_tx_save: '',
      scenarioCode: '',
      is_issue_key_enabled: '', 
    },
    selected_scenario_desc: '',
    global_selected_me: [],
    global_issues: [],
    isDrillDown: false,
    inputs: {},
    sessionData: {},
  };

  GENERAL_CONFIG: any = {};
  filterGroupData = '';
  actionKey = '';
  insuranceSaveBtn = true;
  bsla_filter: any;
  selected_client: any;
  raw_data: any[] = [];
  detail_diagnostic_data: any = {};
  durationInSeconds = 5;
  pRaw_data = '';

  param = { ein_no: '', tax_year: '', chart_type: '' };

  states = [
    { name: 'Alabama', code: 'AL' },
    { name: 'Alaska', code: 'AK' },
    { name: 'Arizona', code: 'AZ' },
    { name: 'Arkansas', code: 'AR' },
    { name: 'California', code: 'CA' },
    { name: 'Colorado', code: 'CO' },
    { name: 'Connecticut', code: 'CT' },
    { name: 'Delaware', code: 'DE' },
    { name: 'District Of Columbia', code: 'DC' },
    { name: 'Florida', code: 'FL' },
    { name: 'Georgia', code: 'GA' },
    { name: 'Hawaii', code: 'HI' },
    { name: 'Idaho', code: 'ID' },
    { name: 'Illinois', code: 'IL' },
    { name: 'Indiana', code: 'IN' },
    { name: 'Iowa', code: 'IA' },
    { name: 'Kansas', code: 'KS' },
    { name: 'Kentucky', code: 'KY' },
    { name: 'Louisiana', code: 'LA' },
    { name: 'Maine', code: 'ME' },
    { name: 'Maryland', code: 'MD' },
    { name: 'Massachusetts', code: 'MA' },
    { name: 'Michigan', code: 'MI' },
    { name: 'Minnesota', code: 'MN' },
    { name: 'Mississippi', code: 'MS' },
    { name: 'Missouri', code: 'MO' },
    { name: 'Montana', code: 'MT' },
    { name: 'Nebraska', code: 'NE' },
    { name: 'Nevada', code: 'NV' },
    { name: 'New Hampshire', code: 'NH' },
    { name: 'New Jersey', code: 'NJ' },
    { name: 'New Mexico', code: 'NM' },
    { name: 'New York', code: 'NY' },
    { name: 'North Carolina', code: 'NC' },
    { name: 'North Dakota', code: 'ND' },
    { name: 'Ohio', code: 'OH' },
    { name: 'Oklahoma', code: 'OK' },
    { name: 'Oregon', code: 'OR' },
    { name: 'Pennsylvania', code: 'PA' },
    { name: 'Rhode Island', code: 'RI' },
    { name: 'South Carolina', code: 'SC' },
    { name: 'South Dakota', code: 'SD' },
    { name: 'Tennessee', code: 'TN' },
    { name: 'Texas', code: 'TX' },
    { name: 'Utah', code: 'UT' },
    { name: 'Vermont', code: 'VT' },
    { name: 'Virginia', code: 'VA' },
    { name: 'Washington', code: 'WA' },
    { name: 'West Virginia', code: 'WV' },
    { name: 'Wisconsin', code: 'WI' },
    { name: 'Wyoming', code: 'WY' },
  ];

  countries = [
    { name: 'United States', code: 'US' },
    { name: 'Canada', code: 'CA' },
    { name: 'United Kingdom', code: 'GB' },
    { name: 'Germany', code: 'DE' },
    { name: 'France', code: 'FR' },
    { name: 'Japan', code: 'JP' },
    { name: 'China', code: 'CN' },
    { name: 'India', code: 'IN' },
    { name: 'Australia', code: 'AU' },
    { name: 'Brazil', code: 'BR' },
  ];

  currencies = [
    { name: 'US Dollar', code: 'USD' },
    { name: 'Euro', code: 'EUR' },
    { name: 'British Pound', code: 'GBP' },
    { name: 'Japanese Yen', code: 'JPY' },
    { name: 'Canadian Dollar', code: 'CAD' },
  ];

  constructor(
    private appService: AppService,
    private http: HttpClient,
    private _snackBar: MatSnackBar, private gtwSnackbar: GtwSnackbarService
  ) {
    this.GENERAL_CONFIG = environment;
  }

  initGlobalParams(): void {
    const TEMP_TAX_YEAR: any[] = [];
    _.forEach(this.appService.TAX_YEARS, (value: any) => {
      if (Array.isArray(value)) {
        value.forEach((v: any) => {
          if (v && typeof v === 'object' && v.value !== undefined) {
            TEMP_TAX_YEAR.push(v);
          }
        });
      } else if (value && typeof value === 'object' && value.value !== undefined) {
        TEMP_TAX_YEAR.push(value);
      }
    });
    this.global.inputs.tax_year = {
      name: 'tax_year',
      label: 'Tax Year',
      selected: {},
      values: TEMP_TAX_YEAR,
    };

    const cfgDefault = this.appService.SERVER_CONFIG?.clientConfig?.defaultTaxYear;

    let resolvedTaxYear: any = null;

    if (cfgDefault != null && cfgDefault !== '') {
      resolvedTaxYear = _.find(TEMP_TAX_YEAR, (ty: any) =>
        String(ty.value) === String(cfgDefault)
      );
    }

    if (!resolvedTaxYear && TEMP_TAX_YEAR.length > 0) {
      resolvedTaxYear = TEMP_TAX_YEAR[0];
      console.warn('[GlobalService] defaultTaxYear not matched, falling back to first available:', resolvedTaxYear.value);
    }

    if (resolvedTaxYear) {
      this.global.inputs.tax_year.selected = resolvedTaxYear;
      this.global.globalParams.tax_year = resolvedTaxYear.value;
      this.global.globalParams.scenario = resolvedTaxYear.scenario;
      this.global.globalParams.scenario_desc = resolvedTaxYear.scenario_desc;
      this.global.globalParams.scenarioCode = resolvedTaxYear.scenario_type_code;
      this.global.globalParams.scenario_v1 = resolvedTaxYear.scenario;
      this.global.globalParams.is_issue_key_enabled = resolvedTaxYear.is_issue_key_enabled;

      const selectedScenario: any = _.find(
        resolvedTaxYear.scenarios,
        { scenario: resolvedTaxYear.scenario }
      );
      if (selectedScenario) {
        this.global.globalParams.jcd_key = selectedScenario.jcd_key;
        this.global.globalParams.is_locked = selectedScenario.is_locked;
        this.global.globalParams.scenarioCode = selectedScenario.scenario_type_code;
        this.global.globalParams.is_issue_key_enabled = selectedScenario.is_issue_key_enabled;
      }
    }
  }

  setUserSession(paramName: any, paramValue: any): void {
    this.global.sessionData[paramName] = paramValue;
  }

  getUserSession(paramName: any): any {
    return this.global.sessionData[paramName];
  }

  setInputTaxYears(taxYearData: any): void {
    this.global.inputs.tax_year = taxYearData;
    this.global.inputs.tax_year.selected = taxYearData.selected;
    this.global.globalParams.tax_year = taxYearData.selected.value;
    this.global.globalParams.scenario = taxYearData.selected.scenario;
    this.global.globalParams.scenario_v1 = taxYearData.selected.scenario;

    const selectedScenario: any = _.find(
      this.global.inputs.tax_year.selected.scenarios,
      { scenario: this.global.globalParams.scenario }
    );

    if (selectedScenario) {
      this.global.globalParams.jcd_key = selectedScenario?.jcd_key;
      this.global.globalParams.is_locked = selectedScenario?.is_locked;
    }
    this.globalParamsChanged$.next();
  }

  getEIN(): string { return this.param.ein_no; }
  getTAXYEAR(): string { return this.param.tax_year; }
  getChartType(): string { return this.param.chart_type; }

  setFilters(_workspace: any): void {
    const gp = this.global.globalParams || {};

    const normalized = {
      jcd_key: _workspace?.jcd_key ?? _workspace?.JCD_KEY,
      jcd_ta_key: _workspace?.jcd_ta_key ?? _workspace?.JCD_TA_KEY,
      activity_key:
        _workspace?.activity_key ??
        _workspace?.ACTIVITY_KEY ??
        _workspace?.parent?.activity_key ??
        _workspace?.parent?.ACTIVITY_KEY,
      screen_type: _workspace?.screen_type ?? _workspace?.SCREEN_TYPE ?? _workspace?.type,
      screen_key: _workspace?.screen_key ?? _workspace?.SCREEN_KEY,
      is_locked: _workspace?.is_locked ?? _workspace?.IS_LOCKED,
    };

    // Only overwrite when workspace provides a non-empty value.
    if (this.isPresent(normalized.jcd_key)) gp.jcd_key = normalized.jcd_key;
    if (this.isPresent(normalized.jcd_ta_key)) gp.jcd_ta_key = normalized.jcd_ta_key;
    if (this.isPresent(normalized.activity_key)) gp.activity_key = normalized.activity_key;
    if (this.isPresent(normalized.screen_type)) gp.screen_type = normalized.screen_type;
    if (this.isPresent(normalized.screen_key)) gp.screen_key = normalized.screen_key;
    if (this.isPresent(normalized.is_locked)) gp.is_locked = normalized.is_locked;

    this.global.globalParams = gp;
    this.filtersChanged$.next();
  }

  private isPresent(value: any): boolean {
    return value !== undefined && value !== null && value !== '';
  }

  /**
   * Build a globalParams snapshot for a request/modal payload and persist
   * the workspace-level subset (screen_key, jcd_key, jcd_ta_key,
   * activity_key, screen_type, is_locked) back to `this.global.globalParams`.
   *
   * IMPORTANT: filter selections (e.g. `ho_leid`, `me_key`, `filing_key`,
   * arbitrary `param_name`s coming out of `FilterObj.getFilterParams()`)
   * are **only** mixed into the returned snapshot — they are NOT written
   * back to `this.global.globalParams`. Persisting them was the root cause
   * of a leak where a filter chosen on one screen rode along on every
   * subsequent `/getFilters` and grid request on unrelated screens:
   * `data-filters.service.buildGetFiltersHttpParams` and `grid.directive`
   * both `_.merge({}, this.globalService.global?.globalParams || {}, ...)`
   * into outgoing payloads, and `mergeIfPresent` here never deletes —
   * it only overlays — so once `globalParams.ho_leid` was set on screen A
   * it survived navigation to screen B / C / any unrelated screen that
   * lacks its own `ho_leid` filter to overwrite it.
   *
   * Workspace-level keys are still safe to persist because
   * `WorkspaceService.loadTab` -> `globalService.setFilters(activeScreen)`
   * canonically refreshes them on every tab change anyway; persisting them
   * here is just defense in depth for code paths that hit the interceptor
   * before `setFilters` ran (e.g. early-boot HTTP from a CE before
   * `setActivity`).
   */
  hydrateGlobalParamsFromContext(activeScreen: any = {}, filterParams: any = {}): any {
    const activeContext = this.buildActiveContext(activeScreen);

    this.persistWorkspaceContext(activeContext);

    // Build the per-call snapshot AFTER persistence so it reflects the
    // refreshed workspace context, then overlay screen-scoped filter
    // params on top for the caller only.
    const gp = { ...(this.global.globalParams || {}) };

    const normalizedFilterParams = {
      ...filterParams,
      screen_key: filterParams?.screen_key ?? filterParams?.SCREEN_KEY,
      jcd_ta_key: filterParams?.jcd_ta_key ?? filterParams?.JCD_TA_KEY,
      activity_key: filterParams?.activity_key ?? filterParams?.ACTIVITY_KEY,
      screen_type: filterParams?.screen_type ?? filterParams?.SCREEN_TYPE,
      jcd_key: filterParams?.jcd_key ?? filterParams?.JCD_KEY,
    };

    Object.keys(normalizedFilterParams).forEach((key: string) => {
      const val = (normalizedFilterParams as any)[key];
      if (this.isPresent(val)) {
        gp[key] = val;
      }
    });

    return gp;
  }

  private buildActiveContext(activeScreen: any): Record<string, any> {
    return {
      screen_key: activeScreen?.screen_key || activeScreen?.SCREEN_KEY,
      // jcd_key on the screen object is rare (it usually lives on globalParams
      // already, set by initGlobalParams / tax-year changes), but when it is
      // present — e.g. drill-down targets or USER_MENU entries — persist it
      // so the screen-level context overrides any stale tax-year-derived value.
      jcd_key: activeScreen?.jcd_key || activeScreen?.JCD_KEY,
      jcd_ta_key: activeScreen?.jcd_ta_key || activeScreen?.JCD_TA_KEY,
      activity_key:
        activeScreen?.activity_key ||
        activeScreen?.ACTIVITY_KEY ||
        activeScreen?.parent?.activity_key ||
        activeScreen?.parent?.ACTIVITY_KEY,
      screen_type: activeScreen?.screen_type || activeScreen?.SCREEN_TYPE || activeScreen?.type,
      is_locked: activeScreen?.is_locked || activeScreen?.IS_LOCKED,
    };
  }

  private persistWorkspaceContext(activeContext: Record<string, any>): void {
    const gp = { ...(this.global.globalParams || {}) };

    Object.keys(activeContext).forEach((key: string) => {
      const val = activeContext[key];
      if (this.isPresent(val)) {
        gp[key] = val;
      }
    });

    if (!this.isPresent(gp.scenario_v1) && this.isPresent(gp.scenario)) {
      gp.scenario_v1 = gp.scenario;
    }
    if (!this.isPresent(gp.is_issue_key_enabled)) {
      gp.is_issue_key_enabled = 'N';
    }
    if (!this.isPresent(gp.scenarioCode)) {
      gp.scenarioCode = 'RAF';
    }

    gp.issue_id = gp.issue_id || '';
    gp.issue_short_desc = gp.issue_short_desc || '';
    gp.issue_id_for_tx_save = gp.issue_id_for_tx_save || '';

    this.global.globalParams = gp;
  }

  modalLockFilters(lockedFilters: any): void {
    this.global.globalParams.checkLockedbj = {};
    if (!_.isEmpty(lockedFilters)) {
      this.global.globalParams.checkLockedbj = JSON.stringify(lockedFilters);
    } else {
      delete this.global.globalParams['checkLockedbj'];
    }
  }

  setGlobalSelectedMes(selectedMes: any): void {
    this.global.global_selected_me = selectedMes;
  }

  getScenario(tax_year: any): any {
    const defaultObj: any = _.find(this.global.inputs.tax_year.values, {
      value: tax_year,
    });
    if (defaultObj?.scenario) {
      return defaultObj.scenario;
    }
  }

  isIssueIDEnabled(tax_year: any, scenario: any): any {
    const obj = { scenarioCode: '', is_issue_key_enabled: '' };
    let foundScenario: any = '';
    _.find(this.global.inputs.tax_year.values, (i: any) => {
      if (i.value == tax_year) {
        foundScenario = _.find(i.scenarios, { scenario: scenario + '' });
      }
    });
    if (foundScenario?.scenario_type_code) {
      obj.scenarioCode = foundScenario.scenario_type_code;
      obj.is_issue_key_enabled = foundScenario.is_issue_key_enabled;
    }
    return obj;
  }

  getIssue(tax_year: any, scenario: any) {
    let params = new HttpParams();
    params = params.append('tax_year', tax_year);
    params = params.append('scenario', scenario);
    return this.http.get(this.GENERAL_CONFIG.base_url + this.URLs.getIssues, { params });
  }

  getUserMenu(tax_year: any, scenario: any, scenario_type_code: any) {
    let params = new HttpParams();
    params = params.append('tax_year', tax_year);
    params = params.append('scenario', scenario);
    params = params.append('scenario_type_code', scenario_type_code);
    return this.http.get(this.GENERAL_CONFIG.base_url + this.URLs.getUserMenu, { params });
  }

  generateUUID(): string {
    let d = new Date().getTime();
    if (window.performance && typeof window.performance.now === 'function') {
      d += performance.now();
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
  }

  setEIN_TAXYEAR(ein: string, tax_year: string, chart_type: string): void {
    this.param.ein_no = ein;
    this.param.tax_year = tax_year;
    this.param.chart_type = chart_type;
  }

  setFilterGroup(data: any): void { this.filterGroupData = data; }
  getFilterGroup(): any { return this.filterGroupData; }
  setActionKey(key: any): void { this.actionKey = key; }
  getActionKey(): any { return this.actionKey; }
  setInsuranceSaveBtnState(state: any): void { this.insuranceSaveBtn = state; }
  getInsuranceSaveBtnState(): boolean { return this.insuranceSaveBtn; }
  setBslaFilterState(state: any): void { this.bsla_filter = state; }
  getBslaFilterState(): any { return this.bsla_filter; }
  setClientSelection(data: any): void { this.selected_client = data; }
  getClientSelection(): any { return this.selected_client; }
  setRawData(data: any): void { this.raw_data = data; }
  getRawData(): any { return this.raw_data; }
  setpRawData(data: any): void { this.pRaw_data = data; }
  getpRawData(): any { return this.pRaw_data; }
  getStates(): any[] { return this.states; }
  getCountries(): any[] { return this.countries; }
  getCurrencies(): any[] { return this.currencies; }

  getCountryByCode(code: any): any {
    return _.find(this.countries, { code });
  }

  getClients(): any { return this.appService.USER_SETTINGS.user.clients; }
  getClient(): any { return this.appService.USER_SETTINGS.user.client; }

  setDetailDiagData(data: any): void { this.detail_diagnostic_data = data; }
  getDetailDiagData(): any { return this.detail_diagnostic_data; }

  setClient(client_key: any, api_url: any) {
    const body = new FormData();
    body.append('client_key', client_key.toString());
    body.append('fromClientSwitch', 'true');

    return this.http.post(api_url + '/setClient', body).pipe(
      map((res: any) => {
        if (res.callSuccess == '1') {
          return res;
        }
        this.openSnackBar(
          'The requested data could not be saved. If this continues please contact support.',
          'gtw-snackbar--red'
        );
        throwError(new Error('setClient failed'));
        return null;
      })
    );
  }

  getBizHierarchy(params: any) {
    return this.http.get(
      environment.base_url +
        '/getBizzHierarchyFilter?tax_year=' + params.tax_year +
        '&scenario=' + params.scenario +
        '&jcd_key=' + params.jcd_key,
      { params }
    );
  }

  downloadUserGuide(): void {
    this.http.get<any>(environment.admin_api_url + '/getUserGuide')
      .subscribe((response: any) => {
        if (response?.presignedS3Url) {
          const a = document.createElement('a');
          a.href = response.presignedS3Url;
          const urlParts = response.presignedS3Url.split('?')[0].split('/');
          a.download = urlParts[urlParts.length - 1];
          a.target = '_blank';
          a.click();
        }
      });
  }

  openSnackBar(message: string, panelClass: string = '') {
    this.gtwSnackbar.openSnackBar(message, (panelClass || '') as any, true, this.durationInSeconds);
  }
}
